module.exports = __webpack_public_path__ + "img/pc-banner.9d3f9c19.png";